import { SearchBox } from 'office-ui-fabric-react';
import { noSelectionKey } from '../../../../../../utilities/filterAndSortingsUtil';

function isCommandDisabled(selectedKey) {
  return !selectedKey || selectedKey === noSelectionKey;
}

export function getCommandBarItems(
  translator,
  onAdd,
  onEdit,
  onDelete,
  onManageKeys,
  selectedInvitationGroupKey,
) {
  return [
    {
      key: 'addInvitationGroup',
      name: translator(
        'pages.adminInvitationGroups.invitationGroupAdminPanelAndList.addButton',
      ),
      iconProps: {
        iconName: 'Add',
      },
      disabled: false,
      onClick: onAdd,
    },
    {
      key: 'editInvitationGroup',
      name: translator(
        'pages.adminInvitationGroups.invitationGroupAdminPanelAndList.updateButton',
      ),
      iconProps: {
        iconName: 'Edit',
      },
      disabled: isCommandDisabled(selectedInvitationGroupKey),
      onClick: onEdit,
    },
    {
      key: 'deleteInvitationGroup',
      name: translator(
        'pages.adminInvitationGroups.invitationGroupAdminPanelAndList.deleteButton',
      ),
      iconProps: {
        iconName: 'Delete',
      },
      disabled: isCommandDisabled(selectedInvitationGroupKey),
      onClick: onDelete,
    },
    {
      key: 'manageInvitationKeys',
      name: translator(
        'pages.adminInvitationGroups.invitationGroupAdminPanelAndList.manageKeysButton',
      ),
      iconProps: {
        iconName: 'AddNotes',
      },
      disabled: isCommandDisabled(selectedInvitationGroupKey),
      onClick: onManageKeys,
    },
  ];
}

export function getCommandBarSearchFilter(
  translator,
  filter,
  handleFilterChange,
) {
  return [
    {
      key: 'filter',
      name: translator(
        'pages.adminInvitationGroups.invitationGroupAdminPanelAndList.filterText',
      ),
      onRender: () => (
        <SearchBox
          styles={{ root: { width: 200, marginTop: '6px' } }}
          onChange={(_, value) => handleFilterChange(value)}
          placeholder={translator(
            'pages.adminInvitationGroups.invitationGroupAdminPanelAndList.filterText',
          )}
          value={filter || ''}
          ariaLabel={translator('ariaLabel.pageHeaderSearch')}
        />
      ),
    },
  ];
}
